const PRODUCT_DEVELOPMENT_STATES = {
  locked: 'locked',
  readyToDevelop: 'ready_to_develop',
  developed: 'developed'
}

export default PRODUCT_DEVELOPMENT_STATES
